document.addEventListener('DOMContentLoaded', function() {
    const a_links = document.querySelectorAll('.detail-link');
    
    if (a_links.length === 0) return; 

      a_links.forEach(function(a) {
        const href = a.href; 
        
        // --- iOSのWebView対策ロジック ---
        if (typeof IS_IOS !== 'undefined' && IS_IOS) { 
            a.addEventListener('click', function (e) {
                e.preventDefault(); 
                var w = null;
                try { w = window.open(href, '_blank'); } catch (_) {} 
                if (!w) { location.href = href; } 
            }, { passive: false });
        }

        // --- Android WebView対策ロジック ---
        if (typeof IS_ANDROID_WV !== 'undefined' && IS_ANDROID_WV) { 
            a.addEventListener('click', function (e) {
                var intent = (typeof toIntentUrl === 'function') ? toIntentUrl(href) : null;
                if (!intent) return; 

                e.preventDefault();

                var fallbackTimer = setTimeout(function () {
                    if (document.visibilityState !== 'hidden') {
                        try {
                            var w = window.open(href, '_blank', 'noopener');
                            if (!w) location.href = href; 
                        } catch (_) {
                            location.href = href;
                        }
                    }
                }, 800); 

                function cancelFallback() {
                    if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
                    window.removeEventListener('visibilitychange', onVisibility, true);
                    window.removeEventListener('pagehide', cancelFallback, true);
                    window.removeEventListener('blur', cancelFallback, true);
                }
                function onVisibility() {
                    if (document.visibilityState === 'hidden') cancelFallback();
                }

                window.addEventListener('visibilitychange', onVisibility, true);
                window.addEventListener('pagehide', cancelFallback, true);
                window.addEventListener('blur', cancelFallback, true);

                try { location.href = intent; } catch (_) {}
            }, { passive: false });
        }
    }); 
});